import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { User, Settings, LogOut, ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { cn } from '@/lib/utils';

export function UserDropdown() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className="flex items-center gap-3 p-2 rounded-lg hover:bg-bg-elevated-hover transition-colors w-full">
          <div className="w-10 h-10 rounded-full overflow-hidden bg-zzing-purple-500/20 flex items-center justify-center flex-shrink-0">
            {user.photo ? (
              <img src={user.photo} alt={user.name} className="w-full h-full object-cover" />
            ) : (
              <span className="text-sm text-zzing-purple-500 font-semibold">
                {user.name.charAt(0).toUpperCase()}
              </span>
            )}
          </div>
          <div className="flex-1 min-w-0 text-left">
            <p className="text-sm font-medium text-text-primary truncate">{user.name}</p>
            <p className="text-xs text-text-muted truncate">{user.email}</p>
          </div>
          <ChevronDown className="w-4 h-4 text-text-muted flex-shrink-0" />
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className={cn(
            'min-w-[200px] bg-bg-elevated rounded-lg shadow-xl border border-subtle p-1',
            'animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95'
          )}
          sideOffset={8}
          align="end"
        >
          <DropdownMenu.Item
            className="flex items-center gap-3 px-3 py-2 rounded-md text-sm text-text-primary hover:bg-bg-elevated-hover cursor-pointer outline-none"
            onSelect={() => navigate('/profiel')}
          >
            <User className="w-4 h-4" />
            Mijn profiel
          </DropdownMenu.Item>

          <DropdownMenu.Item
            className="flex items-center gap-3 px-3 py-2 rounded-md text-sm text-text-primary hover:bg-bg-elevated-hover cursor-pointer outline-none"
            onSelect={() => navigate('/instellingen')}
          >
            <Settings className="w-4 h-4" />
            Instellingen
          </DropdownMenu.Item>

          <DropdownMenu.Separator className="h-px bg-subtle my-1" />

          <DropdownMenu.Item
            className="flex items-center gap-3 px-3 py-2 rounded-md text-sm text-red-400 hover:bg-red-500/10 cursor-pointer outline-none"
            onSelect={handleLogout}
          >
            <LogOut className="w-4 h-4" />
            Uitloggen
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
